import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './Components/home/home.component';
import { ExamplesComponent } from './Components/examples/examples.component';
import { FeaturesComponent } from './Components/features/features.component';
import { PricingComponent } from './Components/pricing/pricing.component';
import { EnterpriseComponent } from './Components/enterprise/enterprise.component';
import { wordpluginComponent } from './Components/word-plugin/word-plugin.component';
import { TrinkaCloudComponent } from './Components/trinka-cloud/trinka-cloud.component';
import { AboutUsComponent } from './Components/about-us/about-us.component';
import { ContactUsComponent } from './Components/contact-us/contact-us.component';
import { WorkWithUsComponent } from './Components/work-with-us/work-with-us.component';
import { PrivacyPolicyComponent } from './Components/privacy-policy/privacy-policy.component';
import { TermServicesComponent } from './Components/term-services/term-services.component';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';
import { GcEditorComponent } from './Components/gc-editor/gc-editor.component';
import { WhitePaperComponent } from './Components/white-paper/white-paper.component';
import { AutoEditComponent } from './Components/auto-edit/auto-edit.component';
import { PublicationChecksComponent } from './Components/publication-checks/publication-checks.component';
import { BrowserPluginComponent } from './Components/browser-plugin/browser-plugin.component';
import { AffiliatesComponent } from './Components/affiliates/affiliates.component';
import { TryADemoComponent } from './Components/try-ademo/try-ademo.component';
import { FAQComponent } from './Components/faq/faq.component';
import { TrinkaVsGrammarlyComponent } from './Components/trinka-vs-grammarly/trinka-vs-grammarly.component';
import { TrinkaVsGingerComponent } from './Components/trinka-vs-ginger/trinka-vs-ginger.component';
import { TrinkaVsLanguagetoolComponent } from './Components/trinka-vs-languagetool/trinka-vs-languagetool.component';
import { TrinkaVsWritefullComponent } from './Components/trinka-vs-writefull/trinka-vs-writefull.component';
import { LifeSciencesMedicineAndPharmaComponent } from './Components/enterprise/life-sciences-medicine-and-pharma/life-sciences-medicine-and-pharma.component';
import { LanguageServicesPublishingAndMediaComponent } from './Components/enterprise/language-services-publishing-and-media/language-services-publishing-and-media.component';
import { AcademicInstitutionsComponent } from './Components/enterprise/academic-institutions/academic-institutions.component';
import { K12AndElearningComponent } from './Components/enterprise/k12-and-elearning/k12-and-elearning.component';
import { TechnologyPlatformsComponent } from './Components/enterprise/technology-platforms/technology-platforms.component';

import { ConsistencyChecksComponent } from './Components/features/consistency-checks/consistency-checks.component';
import { PersonalDictionaryComponent } from './Components/features/personal-dictionary/personal-dictionary.component';
import { CreditsComponent } from './Components/features/credits/credits.component';
import { PlagiarismCheckerComponent } from './Components/features/plagiarism-checker/plagiarism-checker.component';
import { APIComponent } from './Components/enterprise/api/api.component';
import { PunctuationCheckerComponent } from './Components/punctuation-checker/punctuation-checker.component';
import { SpellCheckerComponent } from './Components/spell-checker/spell-checker.component';
import { SentenceCheckerComponent } from './Components/sentence-checker/sentence-checker.component';
import { CitationCheckerComponent } from './Components/features/citation-checker/citation-checker.component';
import { CitationSampleReportComponent } from './Components/features/citation-checker/citation-sample-report/citation-sample-report.component';
import { BeijingInstituteComponent } from './Components/beijing-institute/beijing-institute.component';
import { OfferRegistrationFormComponent } from './Components/offer-registration-form/offer-registration-form.component';
import { DocumarkComponent } from './Components/features/documark/documark.component';

const routes: Routes = [
  {
    path: "",
    component: HomeComponent,
  },
  {
    path: "features",
    component: FeaturesComponent,
  },
  {
    path: "examples",
    component: ExamplesComponent,
  },
  {
    path: "pricing",
    component: PricingComponent,
  },
  {
    path: "enterprise",
    component: EnterpriseComponent,
  },
  { path: "enterprise/life-sciences-medicine-and-pharma", component: LifeSciencesMedicineAndPharmaComponent },
  { path: "enterprise/language-services-publishing-and-media", component: LanguageServicesPublishingAndMediaComponent },
  { path: "enterprise/academic-institutions", component: AcademicInstitutionsComponent },
  { path: "enterprise/k12-and-elearning", component: K12AndElearningComponent },
  { path: "enterprise/technology-platforms", component: TechnologyPlatformsComponent },
  {
    path: "wordplugin",
    component: wordpluginComponent,
  },
  {
    path: "trinkacloud",
    component: TrinkaCloudComponent,
  },
  {
    path: "aboutus",
    component: AboutUsComponent
  },
  {
    path: "contactus",
    component: ContactUsComponent,
  },
  {
    path: "workwithus",
    component: WorkWithUsComponent,
  },
  {
    path: "privacypolicy",
    component: PrivacyPolicyComponent,
  },
  {
    path: "termsofservices",
    component: TermServicesComponent,
  },
  {
    path: "browser-plugin",
    component: BrowserPluginComponent,
  },
  {
    path: "trinka-vs-grammarly-vs-language-tool",
    component: WhitePaperComponent,
  },
  {
    path: "auto-edit",
    component: AutoEditComponent,
  },

  { path: "trinka-vs-grammarly", component: TrinkaVsGrammarlyComponent },
  { path: "trinka-vs-ginger", component: TrinkaVsGingerComponent },
  { path: "trinka-vs-languagetool", component: TrinkaVsLanguagetoolComponent },
  { path: "trinka-vs-writefull", component: TrinkaVsWritefullComponent },
  { path: "features/consistency-check", component: ConsistencyChecksComponent },
  { path: "features/personal-dictionary", component: PersonalDictionaryComponent },
  { path: "features/publication-readiness-checks", component: PublicationChecksComponent },
  { path: "features/auto-file-edit", component: AutoEditComponent },
  { path: "features/credits", component: CreditsComponent },
  { path: "features/plagiarism-check", component: PlagiarismCheckerComponent },
  { path: "features/documark", component: DocumarkComponent},
  { path: "enterprise/grammar-checker-api", component: APIComponent },
  { path: "punctuation-checker", component: PunctuationCheckerComponent },
  { path: "spell-checker", component: SpellCheckerComponent },
  { path: "sentence-checker", component: SentenceCheckerComponent },
  { path: "features/citation-checker", component: CitationCheckerComponent },
  { path: "citation-checker/sample-report", component: CitationSampleReportComponent },
  // {
  //   path: "try-a-demo",
  //   component: GcEditorComponent,
  // },
  {
    path: "try-a-demo",
    component: TryADemoComponent,
  },
  {
    path: "auto-edit",
    component: AutoEditComponent,
  },
  {
    path: "publication-check",
    component: PublicationChecksComponent,
  },
  {
    path: "affiliates",
    component: AffiliatesComponent,
  },
  {
    path: "faqs",
    component: FAQComponent,
  },
  {
    path: "grammar-checker",
    component: GcEditorComponent,
  },
  {
    path: "beijing-institute-petrochemical-technology-helpdesk",
    component: BeijingInstituteComponent,
  },
  {
    path: "cwg-university-offer",
    component: OfferRegistrationFormComponent,
  },
  { path: "news",  loadChildren: () => import('./modules/news/news.module').then(m => m.NewsModule)},
  {
    path: '**',
    component: PageNotFoundComponent,
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
